import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { RecommendationsModel } from 'lumen/routes/hotel/settings/recommendations';

export default class HotelSettingsRecommendationsDynamicRateRangesRoute extends Route {
  @service declare access: Services['access'];
  @service declare router: Services['router'];

  beforeModel(): void {
    if (!this.access.hasPricingAssistantDynamicRatePricingFeature) {
      this.router.transitionTo('hotel.settings.recommendations');
    }
  }

  model(): RecommendationsModel {
    return this.modelFor(
      'hotel.settings.recommendations',
    ) as RecommendationsModel;
  }
}
